import { render, staticRenderFns } from "./BlocksPanel.vue?vue&type=template&id=3d4709c2&"
import script from "./BlocksPanel.vue?vue&type=script&lang=js&"
export * from "./BlocksPanel.vue?vue&type=script&lang=js&"
import style0 from "./BlocksPanel.vue?vue&type=style&index=0&id=3d4709c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports